import React from 'react';
import {Col, Row} from 'react-bootstrap';

import {EmptyMessageDisplay} from "../EmptyMessageDisplay";
import {ActivityFeedGroup} from "./ActivityFeedGroup";

export const ActivityFeed = props => {
    const {
        events,
        hasFilters,
        hasMoreEvents,
        onClearFiltersClick = () => {},
        onLoadMoreClick = () => {},
        isLoading = false,
    } = props;

    return <Row className="sb-activity-feed">
        <Col xs={12}>
            {
                (!isLoading && events?.length === 0) ?
                    <EmptyMessageDisplay
                        ItemName={"activities"}
                        HasFilters={hasFilters}
                        ClearFilters={onClearFiltersClick}
                    /> :
                    null
            }
            {
                events?.map?.(({ key, value }) =>
                    <ActivityFeedGroup
                        key={key}
                        title={key}
                        events={value}
                    />
                )
            }
        </Col>
        {
            (hasMoreEvents || isLoading) ?
                <Col xs={12}>
                    <div className="sb-activity-feed-load-more" onClick={onLoadMoreClick}>
                        {
                            isLoading ? "Loading..." : "Load More"
                        }
                    </div>
                </Col> :
                <Col xs={12}>
                    <div className="sb-activity-feed-cant-load-more">
                        You've reached the end of this activity feed.
                    </div>
                </Col>
        }
    </Row>;
};


